@if (config && data) {
  <section class="PaymentCard">
    <div class="PaymentCard__Main">
      <div class="PaymentCard__Header">
        <div class="PaymentCard__HeaderInfo">
          <h4 class="PaymentCard__HeaderTitle">{{ title }}</h4>
          @if (isPaymentPillStatusVisible && !config.hideAccountStatus) {
            <status
              class="PaymentCard__HeaderStatus"
              [config]="{
                label: data.bill_status,
                statuses: billStatuses,
              }"
            >
            </status>
          }
        </div>
        <div class="PaymentCard__HeaderWrapper">
          <h4
            class="PaymentCard__PriceAmount u-flex u-justifyEnd u-alignCenter"
          >
            {{ amount }}
          </h4>
          @if (data.total_amount_due_tooltip) {
            <tooltip
              data-test-id="paymentCardTooltip"
              [config]="getTooltip(data.total_amount_due_tooltip)"
            ></tooltip>
          }
        </div>
      </div>
      <section class="PaymentCard__Info">
        <p class="PaymentCard__price-due">{{ getConditionLabel() }}</p>
        <section class="PaymentCard__Details">
          @for (detail of details; track detail) {
            <div class="u-flex">
              @if (detail[config.details.left.prop]) {
                <p class="PaymentCard__Detail">
                  @if (config.details.left.label) {
                    <span>{{ config.details.left.label }} </span>
                  }
                  {{ detail[config.details.left.prop] }}
                </p>
              }
              @if (
                detail[config.details.left.prop] && config.details.right.label
              ) {
                <p class="PaymentCard__Detail">
                  <span>{{ config.details.right.label }} </span>
                  {{ detail[config.details.right.prop] }}
                </p>
              }
            </div>
          }
          @if (shouldDisplayAutopay) {
            <div class="u-flex u-alignCenter">
              <p class="PaymentCard__Detail">{{ config.autopay.label }}</p>
              @if (data.autopay_tooltip) {
                <tooltip [config]="getTooltip(data.autopay_tooltip)"></tooltip>
              }
              @if (autopay === 'ON') {
                <a
                  class="PaymentCard__HeaderAutopayValue"
                  [routerLink]="autopayUrl"
                  >&nbsp;{{ autopay }}</a
                >
              }
              @if (autopay === 'OFF') {
                <span
                  class="PaymentCard__HeaderAutopayValue"
                  [routerLink]="autopayUrl"
                  >&nbsp;{{ autopay }}</span
                >
              }
            </div>
          }
        </section>
      </section>
    </div>
    @if (data.status_message) {
      <section class="PaymentCard__Error">
        <message-banner
          [config]="{
            icon: 'warning',
            type: 'error',
            message: data.status_message,
          }"
        >
        </message-banner>
      </section>
    }
    @if (data.autopay_status_message && autopay === 'ON') {
      <section
        data-test-id="auto-pay-banner"
        class="PaymentCard__AutopayStatusMessage"
      >
        <message-banner
          [config]="{
            icon: autopayService.getAutopayIcon(
              data.autopay_status_message_type.toLowerCase()
            ),
            type: autopayService.getAutopayType(
              data.autopay_status_message_type.toLowerCase()
            ),
            message: data.autopay_status_message,
          }"
        >
        </message-banner>
      </section>
    }
    @for (coverage of data.product_coverages_billed; track coverage) {
      @if (coverage.status_message) {
        <section class="PaymentCard__Error">
          <message-banner
            [config]="{
              icon: 'warning',
              type: 'error',
              message: coverage.status_message,
            }"
          >
          </message-banner>
        </section>
      }
    }
    @if (billNumber || billPeriod) {
      <payment-card-bill-number
        [billNumber]="billNumber"
        [config]="config"
        [billPeriod]="billPeriod"
      ></payment-card-bill-number>
    }
    <footer class="PaymentCard__Footer">
      <a [routerLink]="accountDetailUrl">
        <zip-button
          [config]="config.footer.view_details_button"
          ariaDescription="view payment details"
        ></zip-button>
      </a>
      @if (data.is_payment_allowed && !config.sso) {
        <zip-button
          class="PaymentCard__FooterSelect"
          [config]="paymentButtonConfig"
          [disabled]="isMakePaymentDisabled"
          (zipButtonClicked)="makePaymentClicked()"
          ariaDescription="Make a payment"
        >
        </zip-button>
      }
      @if (data.is_payment_allowed && config.sso) {
        <sso-payment [config]="config.sso"> </sso-payment>
      }
    </footer>
  </section>
}
